import { render, staticRenderFns } from "./userHospital.vue?vue&type=template&id=1fa9887a&"
import script from "./userHospital.vue?vue&type=script&lang=js&"
export * from "./userHospital.vue?vue&type=script&lang=js&"
import style0 from "./userHospital.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports